import { Group, Stack } from '@mantine/core';
import type { MinifiedTask } from '../../../../../api/tasks-client/task-client.type';
import i18n from '../../../../../base-dictionary';
import { formatDate } from '../../../../../helpers/date-time-helpers';
import { capitalizeFirstLetter } from '../../../../../helpers/string-helpers/string-helpers';
import { secondaryBase } from '../../../../../styles/design-tokens';
import { Icon } from '../../../../../ui-library/icon/icon';
import { Tooltip } from '../../../../../ui-library/tooltip/tooltip';
import { Text } from '../../../../../ui-library/typography/typography';
import { SideSectionInfoItem } from '../../../initiative-list/side-section/side-section-info-item';

type Props = {
  task: MinifiedTask;
};

export const SideSectionInfo = ({ task }: Props) => {
  const epicLink = task.epic ? (
    <Group
      gap={4}
      wrap="nowrap"
      style={{ cursor: 'pointer', minWidth: 0 }}
      onClick={() => {
        if (task.epic?.url) {
          window.open(task.epic.url, '_blank', 'noopener, noreferrer');
        }
      }}
    >
      <Text
        size="tiny"
        color={secondaryBase}
        style={{
          lineHeight: '10px',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {task.epic?.title || '-'}
      </Text>
      <Tooltip variant="white" label={i18n.t('common.visit_source_page')} position="right">
        <Icon name="arrow_outward" size={12} color={secondaryBase} style={{ flexShrink: 0 }} pointer />
      </Tooltip>
    </Group>
  ) : (
    '-'
  );

  return (
    <Stack gap={4}>
      {task.epic && <SideSectionInfoItem label={i18n.t('common.epic')} value={epicLink} />}
      <SideSectionInfoItem label={i18n.t('strategy.initiatives.metrics.points')} value={task.points || '-'} />
      <SideSectionInfoItem label={i18n.t('common.type')} value={capitalizeFirstLetter(task.type)} />
      <SideSectionInfoItem label={i18n.t('common.created')} value={formatDate(task.created_date)} />
    </Stack>
  );
};
